<app-loader *ngIf="isLoading"></app-loader>

<div *ngIf="!(isupdateUser || isupdateProfile)">
    <h4 class="q-heading mb-4">
        <span><img [src]="'IMAGES.BACKARROW'|translate" (click)="goBack()" alt="" class="me-2" /></span>
        {{ "MANAGEUSER.ADDUSER" | translate }}
    </h4>
</div>

<div class="bg-white p-3 p-md-4 mb-0 add-device-page border-radius-6">
    <div class="col-md-12 mb-5 mt-4" id="addUserFrom">
        <form [formGroup]="addUserForm" class="q-addDeviceModal">
            <div class="form-div row">
                <div class="col-md-5 col-sm-6 me-5">
                    <div class="form-group mb-4 w-100">
                        <label for="name" class="q-form-label">{{ "MANAGEUSER.NAME" | translate
                            }}*</label>
                        <input type="text" #testInput autocomplete="off" minlength="3" maxlength="50" (keypress)="
keyPressAlphaNumericWithCharacters($event, 'name')
" (keydown)="removeSpace($event, 'name')" (keydown)="onlyAlphabets($event)"
                            placeholder="{{ 'MANAGEUSER.PLEASEENTERNAME' | translate }}"
                            (input)="checkForUpdateUserName($event)" class="q-form-control outlineNone w-100 px-3"
                            formControlName="name" />
                    </div>
                    <div class="form-group mb-4 w-100">
                        <label for="email" class="q-form-label">{{"MANAGEUSER.EMAIL" | translate}}*</label>
                        <span
                            *ngIf="isEmailVerified && !isupdateUser && this.addUserForm.controls['role'].value == CommonEnum.CHILD">
                            <img src="assets/images/success.svg" alt="" class="ms-1" />
                        </span>
                        <div class="d-flex w-100 justify-content-between align-items-center">
                            <div class="w-100 d-flex relative buttonIn">
                                <input type="email" id="emailField" [readonly]="false" autocomplete="off"
                                    class="w-100 q-form-control outlineNone px-3"
                                    placeholder="{{'MANAGEUSER.EMAILPLACEHOLDER' | translate }}" minlength="8"
                                    [(ngModel)]="emailValue" (input)="checkForUpdateEmail($event)" maxlength="100"
                                    formControlName="email" (keydown)="removeSpace($event, 'email')"
                                    (keypress)="keyPressAlphaNumericWithCharacters($event, 'email')" />
                                <button [ngStyle]="{
  width: selectedLanguage !== 'en' ? '145px' : '35px',
  'font-size': selectedLanguage !== 'en' ? '14px' : null
}" *ngIf="!isupdateUser && addUserForm.controls['role'].value == CommonEnum.CHILD && !isEmailVerified && emailValue!=''"
                                    type="button" class="send-otp-button"
                                    [ngClass]="!isEmailVerified?'otp-btn':'otp-invalid-btn'" (click)="emailOTP()"
                                    [disabled]="addUserForm.controls['email'].status == 'INVALID' && isEmailVerified">{{"MANAGEUSER.SENDOTP"
                                    |
                                    translate}}</button>

                                <button [ngStyle]="{
  width: selectedLanguage !== 'en' ? '145px' : '35px',
  'font-size': selectedLanguage !== 'en' ? '14px' : null
}" *ngIf="isupdateUser && addUserForm.controls['role'].value == CommonEnum.CHILD && isEmailVerified && emailValue!=''"
                                    type="button" class="send-otp-button"
                                    [ngClass]="!isEmailVerified?'otp-btn':'otp-invalid-btn'" (click)="emailOTP()"
                                    [disabled]="addUserForm.controls['email'].status == 'INVALID' && isEmailVerified">{{"MANAGEUSER.SENDOTP"
                                    |
                                    translate}}</button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="(isupdateProfile || isupdateUser)" class="form-group mb-4 w-100">
                        <label class="q-form-label tooltips">{{ "MANAGEUSER.GENDER" | translate
                            }}</label>
                        <div class="d-flex relative  cursor-pointer">
                            <select id='selectUserType' formControlName="gender" (change)="enableSaveButton()"
                                class="bg-white outlineNone useredit w-100 q-form-control h-45 py-2 form-select transferSelect cursor-pointer addUserSelected">
                                <option *ngIf="!isupdateUser && !isupdateProfile " selected disabled value="">{{
                                    "MANAGEUSER.SELECTGENDER"
                                    | translate}}</option>
                                <option *ngIf="(isupdateUser || isupdateProfile) && updateUser.genderType==null"
                                    selected disabled value=null>{{
                                    "MANAGEUSER.SELECTGENDER"
                                    | translate}}</option>
                                <option value="Male">{{"MYACCOUNT.MALE"| translate}}</option>
                                <option value="Female">{{"MYACCOUNT.FEMALE"| translate}}</option>
                                <option value="Other">{{"MYACCOUNT.OTHER"| translate}}</option>

                            </select>

                            <img src="../../../assets/images/faq-dropdown.svg" alt="" class="down-chevron-dropdown">
                        </div>
                    </div>
                    <div class="form-group mb-4 w-100">
                        <label class="q-form-label tooltips">{{ "MANAGEUSER.ROLES" | translate
                            }}*</label>
                        <div class="dropdown user-tooltip cursor-pointer">
                            <img src="assets/images/UserInfiIcon.svg" alt="" class="ms-1" />
                            <div class="dropdown-content">
                                <div class="d-flex flex-column">

                                    <div><STRONG>{{ "MANAGEUSER.ROLESADDNOTES.SUPERADMIN" |
                                            translate }}
                                        </STRONG>
                                        {{ "MANAGEUSER.ROLESADDNOTES.SUPERADMINNOTE" | translate }}
                                    </div>
                                    <div> <STRONG>{{ "MANAGEUSER.ROLESADDNOTES.ADMIN" | translate }}
                                        </STRONG> {{ "MANAGEUSER.ROLESADDNOTES.ADMINNOTE" |
                                        translate }}
                                    </div>
                                    <div><STRONG>{{ "MANAGEUSER.ROLESADDNOTES.MEMBER" | translate }}
                                        </STRONG> {{ "MANAGEUSER.ROLESADDNOTES.MEMBERNOTE" |
                                        translate
                                        }}
                                    </div>
                                    <div><STRONG>{{ "MANAGEUSER.ROLESADDNOTES.CHILD" | translate }}
                                        </STRONG> {{ "MANAGEUSER.ROLESADDNOTES.CHILDNOTE" |
                                        translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex relative  cursor-pointer">
                            <select id='selectUserType' (change)="isEmailOTPSent?verifyAgain('role'):''"
                                formControlName="role"
                                class="bg-white outlineNone useredit w-100 q-form-control h-45 py-2 form-select transferSelect cursor-pointer addUserSelected">
                                <option selected disabled value="">
                                    {{ "MANAGEUSER.SELECTROLE" | translate }}
                                </option>
                                <option
                                    *ngIf="(isupdateUser || isupdateProfile) && updateUser.roleType === CommonEnum.SUPER_ADMIN"
                                    disabled [value]="CommonEnum.SUPER_ADMIN">{{ "MANAGEUSER.SUPERADMIN" | translate }}
                                </option>
                                <option
                                    *ngIf="loggedInUser.roleType === CommonEnum.SUPER_ADMIN ||((isupdateUser || isupdateProfile) && updateUser.roleType === CommonEnum.ADMIN)"
                                    [value]="CommonEnum.ADMIN">
                                    {{ "MANAGEUSER.ADMIN" | translate }}</option>
                                <option [value]="CommonEnum.MEMBERS">{{ "MANAGEUSER.MEMBER" | translate }}</option>
                                <option [value]="CommonEnum.CHILD">{{ "MANAGEUSER.CHILD" | translate }}</option>

                            </select>

                            <img src="../../../assets/images/faq-dropdown.svg" alt="" class="down-chevron-dropdown"
                                *ngIf="!(isupdateUser || isupdateProfile) ">
                        </div>
                    </div>
                    <ng-container
                        *ngIf=" forgotPasswordErrorMessage!='' && isVerified==false && isSentOTP==true && timeOver">
                        <p class="errMessage">{{ forgotPasswordErrorMessage }}</p>
                    </ng-container>
                    <ng-container *ngIf="addUserErrorMessage && this.addUserForm.invalid">
                        <p class="errMessage">{{ addUserErrorMessage }}</p>
                    </ng-container>


                </div>
                <div *ngIf="(isupdateProfile || isupdateUser)" class="col-md-5 col-sm-6">
                    <div class="form-group mb-4 w-100">
                        <label for="name" class="q-form-label">{{ "MYACCOUNT.PHONENO" | translate }}<span class=""><span
                                    *ngIf="dialCodeNotInd==91 && isVerified">
                                    <img src="assets/images/success.svg" alt="" class="ms-1" />
                                </span></span></label>
                        <div class="d-flex align-items-center buttonIn w-100">
                            <ngx-intl-tel-input [cssClass]="'q-form-control outlineNone'" style="width: 100%;"
                                [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                                [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                                customPlaceholder="{{'SIGNUP.ENTERYOURMBLNO'|translate}}"
                                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                [selectFirstCountry]="false" [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
                                [phoneValidation]="true" [disabled]="true" name="phone" type="number"
                                formControlName="phone" (keydown)="removeSpace($event,'name');resetvalues()"
                                (input)="mobileValueChange($event)" (focusout)="onFocusOutMobile($event)"
                                (countryChange)="onPhoneChange($event)">
                            </ngx-intl-tel-input>


                            <button type="button" [ngStyle]="{
  width: selectedLanguage !== 'en' ? '145px' : null,
  'font-size': selectedLanguage !== 'en' ? '14px' : null
}" class="send-otp-button" *ngIf="!verifyMobileNumber && !isSentOTP && this.dialCodeNotInd==91 && (loggedInUser.id == updateUser?.id || isupdateProfile)"
                                [ngClass]="isVerified==true || addUserForm.controls['phone'].value?.number?.length<8?'otp-invalid-btn':'otp-btn '"
                                [disabled]="addUserForm.controls['phone'].value?.number?.length<8"
                                (click)="verify('Send')">{{"MANAGEUSER.SENDOTP" |
                                translate}}</button>

                        </div>
                        <ng-container *ngIf="otpPhoneError">
                            <p class="errMessage mt-2 mb-0">
                                {{ otpPhoneError }}
                            </p>
                        </ng-container>
                    </div>
                    <div *ngIf="(isupdateProfile || isupdateUser)" class="form-group mb-4 w-100">
                        <label for="name" class="q-form-label">{{ "MANAGEUSER.DATEOFBIRTH" | translate
                            }}</label>
                        <input type="date" #testInput autocomplete="off" minlength="3" maxlength="50" (keypress)="
keyPressAlphaNumericWithCharacters($event, 'name')
" (keydown)="removeSpace($event, 'name')" (keydown)="onlyAlphabets($event) " (change)="onDobChange($event)"
                            class="q-form-control outlineNone w-100 px-3" formControlName="dob"
                            placeholder="'MANAGEUSER.SELECTDOB' | translate" />
                    </div>
                </div>

                <div class="mt-4 d-flex">
                    <div>
                        <button (click)="onAddUser($event)" *ngIf="!isupdateUser" class="add-user-btn" [disabled]="
                                (editButon == true && isVerified == false && isupdateProfile) || 
                                (isEmailVerified == false && addUserForm.controls['role'].value == CommonEnum.CHILD) ||
                                addUserForm.controls['name'].value == null || 
                                addUserForm.controls['name'].value == '' ||
                                addUserForm.controls['email'].value == null ||
                                addUserForm.controls['email'].value == '' ||
                                addUserForm.controls['role'].value == '' ||
                                ((isupdateUser || isupdateProfile) && 
                                (addUserForm.controls['phone'].value?.number == null || addUserForm.controls['phone'].value?.number == ''))
                            " [ngClass]="
                                (editButon == true && isVerified == false && isupdateProfile) ||
                                (isEmailVerified == false && addUserForm.controls['role'].value == CommonEnum.CHILD) ||
                                (isVerified == false && dialCodeNotInd == 91 && isupdateProfile) ||
                                addUserForm.controls['name'].value == null || 
                                addUserForm.controls['name'].value == '' ||
                                addUserForm.controls['email'].value == null ||
                                addUserForm.controls['email'].value == '' ||
                                addUserForm.controls['role'].value == '' ||
                                ((isupdateProfile) && 
                                    (addUserForm.controls['phone'].value?.number == null || addUserForm.controls['phone'].value?.number == '')) ||
                                (addUserForm.controls['role'].value == CommonEnum.CHILD && isEmailOTPSent == false)
                                    ? 'q-addUser-invalid-button'
                                    : 'submit-btn bg-orgclr'
                            ">

                            {{ (isupdateUser || isupdateProfile ? 'MANAGEUSER.SAVE' : 'MANAGEUSER.ADDUSER') | translate
                            }}
                        </button>

                        <button (click)="onAddUser($event)" *ngIf="isupdateUser" class="add-user-btn" [disabled]="
                                (editButon == true && isVerified == false && loggedInUser.id == updateUser?.id) || 
                                this.addUserForm.controls['name'].value == null || 
                                this.addUserForm.controls['name'].value == '' || 
                                this.addUserForm.controls['email'].value == null || 
                                this.addUserForm.controls['email'].value == '' || 
                                this.addUserForm.controls['role'].value == ''
                            " [ngClass]="
                                (editButon == true && isVerified == false && loggedInUser.id == updateUser?.id) || 
                                this.addUserForm.controls['name'].value == null || 
                                this.addUserForm.controls['name'].value == '' || 
                                this.addUserForm.controls['email'].value == null || 
                                this.addUserForm.controls['email'].value == '' || 
                                this.addUserForm.controls['role'].value == ''
                                    ? 'q-addUser-invalid-button' 
                                    : 'submit-btn bg-orgclr'
                            ">
                            {{ (isupdateUser ? 'MANAGEUSER.SAVE' : 'MANAGEUSER.ADDUSER') | translate }}
                        </button>

                    </div>
                    <div class="mx-3">
                        <button type="button" class="q-form-white-submit bg-white cancel-btn"
                            (click)="openManageUser()">
                            {{ "LOGIN.CANCEL" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>


    <div class="modal" id="OtpPopup" data-bs-backdrop="static">
        <div class="modal-dialog opt-popup relative w-auto pointer-events-none otpdialogwidth modal-dialog-centered">
            <div
                class="modal-content border-none rounded-25 shadow-lg relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
                <!-- Modal Header -->
                <div class="mt-0">
                    <h4>
                        <app-main-heading>
                            <span title> {{ "MANAGEUSER.ENTEROTPTITLE" | translate }}</span>
                        </app-main-heading>
                    </h4>
                </div>

                <!-- Modal body -->
                <div class="">
                    <div class="form-group">
                        <div class="d-flex justify-content-center align-items-center mt-1 mb-2">
                            <div>
                                <div class="charClass me-2 me-md-3">
                                    {{ emailResponseOTP }}
                                </div>
                            </div>
                            <div>
                                <ng-otp-input (onInputChange)="onOtpChange($event)"
                                    [config]="{ length: 4, allowNumbersOnly: true }" #ngOtpInput>
                                </ng-otp-input>
                            </div>
                        </div>
                        <ng-container *ngIf="(isEmailOTPSent ||isSentOTP) && timeOver">
                            <div class="d-flex align-items-center justify-content-center my-2">
                                <small>
                                    {{ "RESENDOT.RESENDOTPIN" | translate }}
                                    {{ durationMinutes }}</small>
                            </div>
                        </ng-container>
                        <div *ngIf="!timeOver && (isSentOTP || isEmailOTPSent)"
                            class="d-flex my-2 align-items-center justify-content-center">
                            <span>{{ "LOGIN.DIDNTRECEIVEOTP" | translate }}</span>
                            <button type="button" *ngIf="!timeOver && !isVerified"
                                class="border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2"
                                (click)="verify('ReSend')">
                                {{ "LOGIN.RESEND" | translate }}
                            </button>
                            <button type="button" *ngIf="!timeOver && isEmailOTPSent"
                                class="border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2"
                                (click)="emailOTP()">
                                {{ "LOGIN.RESEND" | translate }}
                            </button>
                        </div>
                    </div>

                    <ng-container *ngIf="otpError">
                        <p class=" d-flex errMessage align-items-center justify-content-center">
                            {{ otpError }}
                        </p>
                    </ng-container>

                    <div class="btn-div mt-4 mb-0" style="text-align: center;">
                        <button type="button" [ngClass]="(otpValue != null || otpValue != undefined) && otpValue.length!=4 ? 'q-invalid-button btn-block submit-btn mb-0'
                  : 'submit-btn btn-block bg-orgclr mb-0 cursor-pointer'" [disabled]="otpValue && otpValue.length!=4"
                            (click)="submitOTP()">
                            {{ "MANAGEUSER.VERIFYOTP" | translate }}
                        </button>
                    </div>
                </div>
                <div style="position: absolute; top: 25px; right: 25px">
                    <span (click)="closeModal()"><img src="./assets/images/otpCancel.svg" alt=""
                            class="ms-xl-4" /></span>

                </div>
            </div>

        </div>

    </div>

    <div class="modal" id="InvitePopUp" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <ng-container *ngIf="showAddUserPopup=='YES'">
                <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered">
                    <div
                        class="modal-content px-4 border-none shadow-lg relative text-center rounded-25 w-100 pointer-events-auto bg-white outline-none">
                        <div class="mt-4">
                            <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
                        </div>
                        <h5 class="fw-bold mt-4">
                            {{ "SUCESSMESSAGE.INVITSUCCESS" | translate }}
                        </h5>
                        <span class="text-xs">{{ "SUCESSMESSAGE.EMAILINVITE" | translate }}
                            {{ emailSentUserName }}</span>
                        <div class="text-center">
                            <div class="q-tab-content-title">
                                <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4"
                                    (click)="backToManageUser()">
                                    {{ "SIGNUP.DONE" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="showAddUserPopup=='CHILD'">
                <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered">
                    <div
                        class="modal-content px-4 border-none shadow-lg relative text-center rounded-25 w-100 pointer-events-auto bg-white outline-none">
                        <div class="mt-4">
                            <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
                        </div>
                        <h5 class="fw-bold mt-4">
                            {{ "SUCESSMESSAGE.CHILD_ADDED_SUCCESS" | translate }}
                        </h5>
                        <div class="text-center">
                            <div class="q-tab-content-title">
                                <button type="button" (click)="openManageUser()"
                                    class="submit-btn bg-orgclr w-auto mt-4 mb-4">
                                    {{ "SIGNUP.DONE" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div>
</div>